import { rootApi } from "..";
import { pettyCashService } from "../../../Api/Services/PettyCashService";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

const pettyCashEndpoints = [
  {
    name: "expenseList",
    type: "query",
    serviceFn: ({ center_id, month }: { center_id: number; month: string }) =>
      pettyCashService.pettyCashExpenseList({ center_id, month }),
    tagType: "PettyCashExpenseInfo",
  },
  {
    name: "expenseCategoryList",
    type: "query",
    serviceFn: (_: void) => pettyCashService.pettyCashExpenseCategories(),
    // tagType: "PettyCashExpenseInfo",
  },
  {
    name: "deleteExpense",
    type: "mutation",
    serviceFn: ({ id }: { id: number }) =>
      pettyCashService.deletePettyCashExpense({ id }),

    tagType: "PettyCashExpenseInfo",
  },
  {
    name: "addPettyCashExpense",
    type: "mutation",
    serviceFn: (pettyCashFormData: FormData) =>
      pettyCashService.submitPettyCashExpenseForm(pettyCashFormData),
    tagType: "PettyCashExpenseInfo",
  },
] as const;

export const pettyCashExpenseApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, pettyCashEndpoints),
});

export const {
  useExpenseListQuery,
  useDeleteExpenseMutation,
  useExpenseCategoryListQuery,
  useAddPettyCashExpenseMutation,
} = pettyCashExpenseApi;
